<template lang="pug">
.cell(:style="{'left': (100 * col.offset / col.totalWidth)+'%', width: (100 * col.width / col.totalWidth) + '%', 'background-color': currentColor}" @mouseover="selected = true" @mouseout="selected = false" :title="col.title" @click="$emit('click', $event)")
  .cell-content(v-show="col.level < 3") {{col.title}}
</template>

<script>
const Chroma = require('chroma-js')

export default {
  props: ['col'],
  data() {
    return {
      internalSelected: false
    }
  },
  computed: {
    selected: {
      get() {
        return this.internalSelected
      },
      set(value) {
        this.internalSelected = value
        this.col.selected = value
      }
    },
    currentColor() {
      return this.internalSelected ? new Chroma.Color(this.col.color).saturate(3).hex() : this.col.color
    }
  }
}
</script>

<style scoped>
.cell {
  position: absolute;
  top: 0;
  bottom: 0;
  border: 1px solid #666;
  padding: 4px;
  border-radius: 4px;
  z-index: 200;
  overflow: hidden;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19);
}

.cell .cell-content {
  text-align: center;
  font-size: 12px;
  line-height: 38px;
}
</style>
